import React from "react";
import { useTranslation } from "react-i18next";
import { InfoIcon } from "@picklebet/ui";
import * as support from "utilities/support";
import * as styles from "./CombosInfo.module.scss";

export const CombosInfo = () => {
  const { t } = useTranslation();
  const openArticle = () => support.open({ labels: ["weblink-combo-multis"] });

  return (
    <span
      role="button"
      tabIndex={0}
      aria-label={t("About Combination Multis")}
      className={styles.trigger}
      onClick={(event) => {
        // Open the article without toggling the section it sits in.
        event.stopPropagation();
        openArticle();
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.stopPropagation();
          event.preventDefault();
          openArticle();
        }
      }}
    >
      <InfoIcon />
    </span>
  );
};
